import React, { useContext } from "react";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import { INecessidade_EA } from "../../../Interfaces/eficiencia_alimentar/plano_de_alimentacao";

import { Paper, TableBody, TableContainer, TableHead, TableRow } from "@mui/material";
import { StyledTableCell, StyledTableCellCabecalho, StyledTableHead } from "../../../Styles/tabelCellStyled/customTableCell";
import LoadingVulpes from "../../../Styles/Loader/loading";
import { get, } from "../../../Services/tokenConfig";
import { func_print } from "../../../Func_genericas/func_print";
import { somaTotal } from "../../../Componentes_modulo/formulas_genericas/formulas_genericas";
import { formatarNumero_recebido_com_casa_decimais } from "../../../Func_genericas/formatar_numero_formato_pt";
import { AuthContext } from "../../../AuthContext/AuthContext";



interface INecessidadeProps {
    rows: INecessidade_EA[];
    setRows: React.Dispatch<React.SetStateAction<INecessidade_EA[]>>;
}

export const NecessidadesAlimentares: React.FC<INecessidadeProps> = ({
    rows,
    setRows,
}) => {
    const location = useLocation();
    const auth = useContext(AuthContext);

    const [isLoading, setIsLoading] = useState(true);



    async function getTabela() {
        try {
            let res = await get(auth.token.cookie_token, `/get_total_necessidades_id_rosto/${location.state.id_identificacao}`);
            if (res.status === 200) {
                setRows(res.data.result.sort((a: any, b: any) => {
                    if (a.id_grupo > b.id_grupo) {
                        return 1;
                    }
                    if (a.id_grupo < b.id_grupo) {
                        return -1;
                    }
                    return 0;
                }));
            }
            setIsLoading(false);
        } catch (error) {
            func_print("getTabela", error, true);
            setIsLoading(false);
        }
    }


    useEffect(() => {
        (async () => {
            await getTabela();
        })();
    }, []);


    return (
        <>
            {isLoading ?
                <LoadingVulpes />
                :
                <>
                    <TableContainer
                        component={Paper}
                        variant="outlined"
                        sx={{
                            height: "auto",
                            width: "auto",
                            margin: 2,
                            padding: 2,
                        }}
                    >
                        <table style={{ width: "100%" }}>
                            <TableHead>
                                <TableRow>
                                    <StyledTableCellCabecalho colSpan={11}
                                        sx={{ fontWeight: 600, fontSize: 14 }}>
                                        2.4. Total das Necessidades Alimentares e Dieta (efetivo
                                        total e ano civil)
                                    </StyledTableCellCabecalho>

                                </TableRow>
                                <TableRow>
                                    <StyledTableHead rowSpan={2}>Efetivo Pecuário</StyledTableHead>
                                    <StyledTableHead rowSpan={2} sx={{ minWidth: 120 }}>CN</StyledTableHead>
                                    <StyledTableHead colSpan={4}>Necessidades alimentares do efetivo (ano civil)</StyledTableHead>
                                    <StyledTableHead colSpan={5}>Tipo de alimento (ton MS)</StyledTableHead>
                                </TableRow>
                                <TableRow>
                                    <StyledTableHead>Matéria Seca (kg/MS/dia)</StyledTableHead>
                                    <StyledTableHead>UFV (Unidades Forrageiras Carne)</StyledTableHead>
                                    <StyledTableHead>Proteína Bruta (kg/MS/dia)</StyledTableHead>
                                    <StyledTableHead>NDF (kg/MS/dia)</StyledTableHead>
                                    <StyledTableHead>Leite substituição</StyledTableHead>
                                    <StyledTableHead>Pastagem</StyledTableHead>
                                    <StyledTableHead>Silagem</StyledTableHead>
                                    <StyledTableHead>Outra forragem</StyledTableHead>
                                    <StyledTableHead>Alimento composto</StyledTableHead>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {rows.map((row, key) => {
                                    return (
                                        <TableRow key={key}>
                                            <StyledTableCell>Grupo Homogéneo {key + 1} </StyledTableCell>
                                            <StyledTableCell sx={{ backgroundColor: "lightgrey" }}>{row.cn === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(row.cn)}</StyledTableCell>
                                            <StyledTableCell sx={{ backgroundColor: "lightgrey" }}>{row.materia_seca === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(row.materia_seca)}</StyledTableCell>
                                            <StyledTableCell sx={{ backgroundColor: "lightgrey" }}>{row.ufv === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(row.ufv)}</StyledTableCell>
                                            <StyledTableCell sx={{ backgroundColor: "lightgrey" }}>{row.proteina === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(row.proteina)}</StyledTableCell>
                                            <StyledTableCell sx={{ backgroundColor: "lightgrey" }}>{row.ndf === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(row.ndf)}</StyledTableCell>
                                            <StyledTableCell sx={{ backgroundColor: "lightgrey" }}>{row.leite === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(row.leite)}</StyledTableCell>
                                            <StyledTableCell sx={{ backgroundColor: "lightgrey" }}>{row.pastagem === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(row.pastagem)}</StyledTableCell>
                                            <StyledTableCell sx={{ backgroundColor: "lightgrey" }}>{row.silagem === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(row.silagem)}</StyledTableCell>
                                            <StyledTableCell sx={{ backgroundColor: "lightgrey" }}>{row.outra_ferragem === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(row.outra_ferragem)}</StyledTableCell>
                                            <StyledTableCell sx={{ backgroundColor: "lightgrey" }}>{row.alimento_composto === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(row.alimento_composto)}</StyledTableCell>
                                        </TableRow>
                                    );
                                })}
                                <TableRow>
                                    <StyledTableHead  >Total</StyledTableHead>
                                    <StyledTableCell sx={{ backgroundColor: "lightgrey" }}>{formatarNumero_recebido_com_casa_decimais(somaTotal(rows, "cn"))}</StyledTableCell>
                                    <StyledTableCell sx={{ backgroundColor: "lightgrey" }}>{formatarNumero_recebido_com_casa_decimais(somaTotal(rows, "materia_seca"))}</StyledTableCell>
                                    <StyledTableCell sx={{ backgroundColor: "lightgrey" }}>{formatarNumero_recebido_com_casa_decimais(somaTotal(rows, "ufv"))}</StyledTableCell>
                                    <StyledTableCell sx={{ backgroundColor: "lightgrey" }}>{formatarNumero_recebido_com_casa_decimais(somaTotal(rows, "proteina"))}</StyledTableCell>
                                    <StyledTableCell sx={{ backgroundColor: "lightgrey" }}>{formatarNumero_recebido_com_casa_decimais(somaTotal(rows, "ndf"))}</StyledTableCell>
                                    <StyledTableCell sx={{ backgroundColor: "lightgrey" }}>{formatarNumero_recebido_com_casa_decimais(somaTotal(rows, "leite"))}</StyledTableCell>
                                    <StyledTableCell sx={{ backgroundColor: "lightgrey" }}>{formatarNumero_recebido_com_casa_decimais(somaTotal(rows, "pastagem"))}</StyledTableCell>
                                    <StyledTableCell sx={{ backgroundColor: "lightgrey" }}>{formatarNumero_recebido_com_casa_decimais(somaTotal(rows, "silagem"))}</StyledTableCell>
                                    <StyledTableCell sx={{ backgroundColor: "lightgrey" }}>{formatarNumero_recebido_com_casa_decimais(somaTotal(rows, "outra_ferragem"))}</StyledTableCell>
                                    <StyledTableCell sx={{ backgroundColor: "lightgrey" }}>{formatarNumero_recebido_com_casa_decimais(somaTotal(rows, "alimento_composto"))}</StyledTableCell>
                                </TableRow>
                            </TableBody>
                        </table>
                    </TableContainer>
                </>
            }
        </>)
}